<template>
  <div>
    <vue-good-table
      style="width: 100%;"
      styleClass="vgt-table condensed"
      ref="myTable"
      :rows="getProducts"
      :columns="columns"
      :search-options="{
        enabled: true,
        trigger: '',
        placeholder: 'Procurar',
        skipDiacritics: true,
      }"
      :pagination-options="paginationOptions">
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>

      <template slot="column-filter" slot-scope="{ column, updateFilters }">
        <v-select
          appendToBody
          v-if="column.filterOptions && column.filterOptions.enabled"
          :options="column.filterOptions.items"
          :placeholder="column.filterOptions.placeholder || 'Selecione'"
          @input="(valuesArray) => updateFilters(column, valuesArray)">
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
          </template>
        </v-select>
      </template>

      <template slot="table-row" slot-scope="order">
        <span class="font-medium" v-if="order.column.field == 'estoqueRegnaparts'">
          {{ order.row.estoqueRegnaparts }} / {{ order.row.estoqueRegnapartsReservado }}
        </span>
        <span class="font-medium" v-else-if="order.column.field == 'estoqueRevestebem'">
          {{ order.row.estoqueRevestebem }} / {{ order.row.estoqueRevestebemReservado }}
        </span>
        <span class="font-medium" v-else>
          {{ order.formattedRow[order.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import helpers from '@/helpers'

export default {
  data() {
    return {
      products: [],
      image: null,
      helpers: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    }
  },
  computed: {
    getProducts() {
      return this.$store.state.products
    }
  },
  methods: {
    sortNumber(a, b) {
      return a < b ? -1 : a > b ? 1 : 0
    },
    getAllLabelFilters() {
      const filters = {}
      filters.marca = this.$store.state.products.map(item => item.marca.trim())
      filters.modelo = this.$store.state.products.map(item => item.modelo.trim())

      for (let filter of Object.keys(filters)) {
        let index = this.columns.findIndex(item => {
          return item.field === filter
        })
        this.setDropdownFilter(index, filters[filter])
      }
    },
    setDropdownFilter(index, label) {
      label.sort((a, b) => a.localeCompare(b))
      label = [...new Set(label)]
      this.$set(this.columns[index], 'filterOptions', {
        enabled: true,
        items: label
      })
    },
    mountTable() {
      this.columns = [{
          label: 'Código',
          field: 'codigo'
        },
        {
          label: 'Descrição EN',
          field: 'descricaoEN'
        },
        {
          label: 'Marca',
          field: 'marca'
        },
        {
          label: 'Modelo',
          field: 'modelo'
        },
        {
          label: 'Reg Disp. / Reserv.',
          field: 'estoqueRegnaparts',
          tdClass: 'text-center',
          sortFn: this.sortNumber
        },
        {
          label: 'Estoque REG Real',
          field: 'estoqueRegnapartsReal',
          sortFn: this.sortNumber
        },
        {
          label: 'Rev Disp. / Reserv.',
          field: 'estoqueRevestebem',
          tdClass: 'text-center',
          sortFn: this.sortNumber
        },
        {
          label: 'Estoque REV Real',
          field: 'estoqueRevestebemReal',
          sortFn: this.sortNumber
        }
      ]
    }
  },
  async created() {
    this.helpers = helpers
    let payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch('fetchProductsItems', payload)
    this.mountTable()
    this.getAllLabelFilters()
  }
}

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
